<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="props.contrat?.typeContrat + ' signé'"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div
        class="flex flex-col gap-[12px]"
        v-if="props.contrat?.signature">
        Le contrat formateur a été signé électroniquement le
        {{ formatDate(props.contrat?.signature?.createdDate) }}
        par {{ props.info_formateur?.prenom }}
        {{ props.info_formateur?.nom }} ({{ props.info_formateur?.email }})
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        variant="primary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';

  import { FormateurContrat } from '@/types/formateur/formateur-contrat';
  import { InfoFormateurSignature } from '@/types/formateur/info-formateur-signature';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      contrat?: FormateurContrat;
      class?: string;
      info_formateur: InfoFormateurSignature;
    }>(),
    {
      class: ''
    }
  );
  const formatDate = (date?: string) => {
    if (!date) return '';
    const [d, t] = date.split(' ');
    return `${d} à ${t}`;
  };
</script>

<style lang="scss" scoped></style>
